import { useEffect, useCallback } from "react";
import axios from "axios";
import { logout } from "../Store/user/action";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const useAxiosInterceptor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cleanupModals = useCallback(() => {
    const hasBootstrap = typeof window.bootstrap !== 'undefined' && window.bootstrap.Modal;
    if (hasBootstrap) {
      document.querySelectorAll('.modal').forEach(modal => {
        const bsModal = window.bootstrap.Modal.getInstance(modal);
        if (bsModal) bsModal.hide();
      });
    }
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.paddingRight = '';
    document.body.style.overflow = '';
  }, []);

  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.data?.error === 'Invalid Token') {
          cleanupModals();
          localStorage.removeItem('token');
          dispatch(logout());
          navigate('/login', { replace: true });
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [dispatch, navigate, cleanupModals]);

  return null;
};

export default useAxiosInterceptor;